import React, { useState, useEffect } from "react";
// import Filter from "../../components/Filter/Filter";
import BreadCrumbs from "../../components/BreadCrumbs/BreadCrumbs";
import Banner from "../../components/Banner/Banner";
import { useNavigate, useParams } from "react-router-dom";
import { setLang } from "../../redux/actions/settings";
import { useDispatch } from "react-redux";

const Landing = () => {
  const { language } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const navigateTo = (e, route) => {
    e.preventDefault();
    navigate(route);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = "eClear - Store";

    if (language === "de" || language === "en") {
      dispatch(setLang(language));
    } else {
      navigate("/not-found");
    }
  }, []);

  // const [isFilterVisible, setIsFilterVisible] = useState(false);
  // const [selectedFilters, setSelectedFilters] = useState([]);
  return (
    <div>
      <BreadCrumbs
        navItems={[
          {
            title: "eClear Store",
          },
        ]}
      />
      <Banner
        image={require("../../assets/images/eclear_header.jpg")}
        title={"eClear Store"}
      />
      {/* <div className="product-filter">
        <label
          id="filter-button"
          onClick={() => {
            setIsFilterVisible(!isFilterVisible);
          }}
        >
          Filter
        </label>
        <label id="close-filter-button">Clear all filters</label>
        {isFilterVisible && <Filter />}
      </div> */}
      <div className="product-list">
        <div className="col-4">
          <a
            href="#"
            onClick={(e) => {
              navigateTo(e, `/store/${language}/product/clearvat`);
            }}
          >
            <img
              alt="ClearVAT"
              src={require("../../assets/images/ClearVAT.jpg")}
              className="product-img"
            />
          </a>
        </div>
        <div className="col-4">
          <a
            href="#"
            onClick={(e) => {
              navigateTo(e, `/store/${language}/product/clearcustoms`);
            }}
          >
            <img
              alt="ClearCustoms"
              src={require("../../assets/images/ClearCustoms.jpg")}
              className="product-img"
            />
          </a>
        </div>
        <div className="col-4">
          <a
            href="#"
            onClick={(e) => {
              navigateTo(e, `/store/${language}/product/vatrules`);
            }}
          >
            <img
              alt="VATRules"
              src={require("../../assets/images/VATRules.jpg")}
              className="product-img"
            />
          </a>
        </div>
        <div className="col-4">
          <a
            href="#"
            onClick={(e) => {
              navigateTo(e, `/store/${language}/product/checkvat-id`);
            }}
          >
            <img
              alt="CheckVAT ID"
              src={require("../../assets/images/CheckVAT ID.jpg")}
              className="product-img"
            />
          </a>
        </div>
      </div>
    </div>
  );
};
export default Landing;
